<div class="logout-dialog">
  <h1 class="warning">ATENÇÃO</h1>

  <div>Sua sessão irá terminar por inatividade em:
    <span class="time-session">
      {{ formatText(count) }}
    </span>
  </div>

  <app-button [text]="'Continuar'" (click)="continueSession()"
      type="primary">
  </app-button>

</div>
